<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <el-radio-group v-model="chartType" size="small" @change="chartTypeChange(dataList)">
          <el-radio-button label="bubbleChart">气泡图</el-radio-button>
          <el-radio-button label="sequentialChart">时序图</el-radio-button>
          <el-radio-button label="radarChart">雷达图</el-radio-button>
        </el-radio-group>
      </template>

        <div class="rander-date" v-if="chartType === 'radarChart'">
          <p class="set-page" @click="lastDate">上一天</p>
          <p>{{new Date(currentDate).format('YYYY-MM-DD')}}</p>
          <p class="set-page" @click="nextDate">下一天</p>
        </div>

        <a-q-i-bubble-chart
          ref="charts"
          v-if="chartType === 'bubbleChart'"
          :data="bubbleChartData"
        />

        <a-q-i-sequential-chart
          ref="charts"
          v-if="chartType === 'sequentialChart'"
          :data="sequentialChartData"
        />

        <a-q-i-radar-chart
          ref="charts"
          v-if="chartType === 'radarChart'"
          :data="radarChartData"
          :date="value"
        />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import AQISequentialChart from '../../../../components/Data/AQISequentialChart'
import AQIBubbleChart from '../../../../components/Data/AQIBubbleChart'
import AQIRadarChart from '../../../../components/Data/AQIRadarChart'

export default {
  name: 'StatisticalAnalysisAQIAnalysis',
  routeInfo: {
    label: 'AQI分析'
  },
  extends: BaseFactorData,
  components: {LayoutContent, AQIBubbleChart, AQISequentialChart, AQIRadarChart},
  data () {
    return {
      chartType: 'bubbleChart',
      query: {
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        isAuditCompleted: false,
        granularity: 24,
        isSiteMerge: false,
        isTimeMerge: false
      },
      dataList: [],
      value: 0,
      options: [],
      currentDate: '',
      bubbleChartData: {},
      sequentialChartData: {},
      radarChartData: {}
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    }
  },
  methods: {
    onAuditCompletedChanged () {
      this.afterSetSiteIds()
    },
    lastDate () {
      let {currentDate, query: {beginTime}} = this
      let tsStep = 24 * 60 * 60000
      let currentDateTs = new Date(currentDate).getTime()
      let beginTimeTs = new Date(new Date(beginTime).format('YYYY-MM-DD')).getTime()
      if (currentDateTs > beginTimeTs) {
        this.value = this.value - 1
        this.currentDate = new Date(currentDateTs - tsStep).format('YYYY-MM-DD')
        this.renderData()
      }
    },
    nextDate () {
      let {currentDate, query: {endTime}} = this
      let tsStep = 24 * 60 * 60000
      let currentDateTs = new Date(currentDate).getTime()
      let endTimeTs = new Date(new Date(endTime).format('YYYY-MM-DD')).getTime()
      if (currentDateTs < endTimeTs) {
        this.value = this.value + 1
        this.currentDate = new Date(currentDateTs + tsStep).format('YYYY-MM-DD')
        this.renderData()
      }
    },
    handleClick (tab, event) {
      let {flag} = this
      this.query.isSiteMerge = flag[tab.name]
      this.getData()
    },
    getDataRenders () {
      return Array.isArray(this.$refs['charts']) ? this.$refs['charts'] : [this.$refs['charts']]
    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.render())
        }
      }, 0)
    },
    changeQuery (query) {
      let data = JSON.parse(JSON.stringify(query))
      delete data.dataType

      return data
    },
    getData () {
      // this.changeLoadStatus(true)
      let query = this.changeQuery(this.query)
      if (query.siteIds.length === 0) {
        this.changeLoadStatus(false)
        return false
      }
      this.$api.Aqi.getAQIData(query).then(backData => {
        if (backData.length === 0) {
          let beginTS = new Date(query.beginTime).getTime()
          let endTS = new Date(query.endTime).getTime()
          let tsStep = query.granularity * 60 * 60000
          let temp = {}
          for (let ts = beginTS; ts <= endTS; ts += tsStep) {
            temp[ts] = {
              dataTime: new Date(ts).format('YYYY-MM-DD')
            }
          }
          this.dataList = []
          this.bubbleChartData = {
            xAxis: Object.values(temp).map(el => el.dataTime),
            series: []
          }
          this.sequentialChartData = {
            xAxis: Object.values(temp).map(el => el.dataTime),
            series: []
          }
          this.radarChartData = {
            xAxis: Object.values(temp).map(el => el.dataTime),
            series: []
          }
          this.renderData()
          return false
        }
        this.dataList = backData
        this.formatData(backData)
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    chartTypeChange (data) {
      this.formatData(data)
      this.renderData()
    },
    formatData (data) {
      let {query: {beginTime, granularity}, chartType, filterSiteMap} = this
      let beginTS = new Date(beginTime).getTime()
      let TSs = data.map(el => new Date(el.dataTime).getTime())
      let endTS = Math.max(...TSs)
      let tsStep = granularity * 60 * 60000
      let dateData = {}
      let level = {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }

      for (let ts = beginTS; ts <= endTS; ts += tsStep) {
        dateData[ts] = {
          dataTime: new Date(ts).format('YYYY-MM-DD')
        }
      }

      switch (chartType) {
        case 'bubbleChart':
          let bubbleChartDataMap = data.reduce((map, el, i) => {
            if (!map[el.siteId]) {
              map[el.siteId] = {
                name: filterSiteMap[el.siteId].name,
                data: [],
                chartSeries: {
                  name: filterSiteMap[el.siteId].name,
                  type: 'scatter',
                  data: []
                }
              }
            }

            map[el.siteId].data.push(el)

            return map
          }, {})
          let bubbleChartSeries = Object.values(bubbleChartDataMap).map(el => {
            let temp = el
            let seriesData = el.data.map(item => {
              let str = ''
              item.pollutantData.forEach(factor => {
                str += factor.rootFactorId + ': <span style="font-weight: blod;">' + Number(factor.value).toFixed(2) + '</span><br />'
              })
              return [
                new Date(item.dataTime).getTime(),
                item.aqi ? Number(Number(item.aqi).toFixed(2)) : '/',
                level[item.grade],
                '主要污染物： ' + item.primaryPollutant,
                '超标准污染物： ' + item.superStandardPollutant,
                str
              ]
            })
            temp.chartSeries.data = seriesData
            return temp.chartSeries
          })

          this.bubbleChartData = {
            xAxis: Object.values(dateData).map(el => el.dataTime),
            series: bubbleChartSeries
          }
          break
        case 'sequentialChart':
          let sequentialDataMap = data.reduce((map, el, i) => {
            let temp = {}
            for (let ts = beginTS; ts <= endTS; ts += tsStep) {
              temp[ts] = {
                dataTime: new Date(ts).format('YYYY-MM-DD')
              }
            }
            if (!map[el.siteId]) {
              map[el.siteId] = {
                name: filterSiteMap[el.siteId].name,
                data: temp,
                chartSeries: {
                  name: filterSiteMap[el.siteId].name + ' AQI',
                  type: 'line',
                  data: [],
                  markLine: {
                    silent: true,
                    lineStyle: {
                      color: '#333'
                    },
                    data: [{
                      yAxis: 50
                    }, {
                      yAxis: 100
                    }, {
                      yAxis: 150
                    }, {
                      yAxis: 200
                    }, {
                      yAxis: 300
                    }]
                  }
                }
              }
            }

            map[el.siteId].data[new Date(el.dataTime).getTime()].aqi = Number(el.aqi).toFixed(2)

            return map
          }, {})

          let series = Object.values(sequentialDataMap).map(el => {
            let temp = el
            let seriesData = Object.values(el.data).map(item => item.aqi ? item.aqi : '')
            temp.chartSeries.data = seriesData
            return temp.chartSeries
          })

          this.sequentialChartData = {
            xAxis: Object.values(dateData).map(el => el.dataTime),
            series: series
          }
          break
        case 'radarChart':
          let colors = [
            '#3ba272',
            '#F44336',
            '#7E57C2',
            '#29B6F6',
            '#26A69A',
            '#8BC34A',
            '#FFEE58',
            '#FF9800',
            '#607D8B',
            '#795548',
            '#EC407A',
            '#AB47BC',
            '#26C6DA',
            '#fe7300',
            '#66BB6A',
            '#D4E157',
            '#FFCA28'
          ]

          let radarChartDataMap = data.reduce((map, el, i) => {
            let temp = {}
            for (let ts = beginTS; ts <= endTS; ts += tsStep) {
              temp[ts] = {
                dataTime: new Date(ts).format('YYYY-MM-DD')
              }
            }
            if (!map[el.siteId]) {
              map[el.siteId] = {
                name: filterSiteMap[el.siteId].name,
                data: temp
              }
            }

            map[el.siteId].data[new Date(el.dataTime).getTime()] = el

            return map
          }, {})

          let radarChartData = Object.values(radarChartDataMap)

          radarChartData.forEach((el, i) => {
            let tempData = {}

            Object.values(el.data).forEach(item => {
              if (!tempData[item.dataTime]) {
                tempData[item.dataTime] = {
                  AQI: '',
                  SO2: '',
                  NO2: '',
                  O3: '',
                  CO: '',
                  'PM2.5': '',
                  PM10: ''
                }
              }
              tempData[item.dataTime].AQI = item.aqi ? Number(item.aqi).toFixed(2) : ''

              if (item.pollutantData) {
                item.pollutantData.forEach(pollutant => {
                  tempData[item.dataTime][pollutant.rootFactorId] = Number(pollutant.value).toFixed(2)
                  if (pollutant.rootFactorId === 'PM2.5') {
                    tempData[item.dataTime]['PM2.5'] = Number(pollutant.value).toFixed(2)
                  }
                })
              }
            })

            el.chartData = tempData
          })

          this.options = Object.values(dateData).map((el, i) => {
            return {
              label: el.dataTime,
              value: i
            }
          })
          this.value = 0
          this.currentDate = beginTime

          this.radarChartData = {
            series: radarChartData.map((el, i) => {
              return {
                name: el.name,
                type: 'radar',
                data: Object.values(el.chartData).map(data => Object.values(data)),
                symbol: 'none',
                itemStyle: {
                  color: colors[i]
                },
                areaStyle: {
                  color: colors[i],
                  opacity: 0.4
                }
              }
            })
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rander-date {
  width: 300px;
  height: 35px;
  position: absolute;
  bottom: 5px;
  right: 0;
  left: 0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 99;
  user-select: none;

  p {
    cursor: pointer;
    margin: 0;
    font-size: 18px;
    border: 1px solid #FFF;
  }
  .set-page {
    font-size: 14px;
    padding: 7px;
    border: 1px solid #DCDFE6;

    &:active {
      color: #409EFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
    &:hover {
      color: #409EFF;
      border-color: #c6e2ff;
      border-radius: 3px;
      background-color: #ecf5ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/03AQIAnalysis/index.vue